export const testimonials = {
  testimonialsPageTitle: "Winner Testimonials — Aprieta y Gana",
  testimonialsPageDescription:
    "Discover the stories of our real winners. Testimonial videos from players who won at Aprieta y Gana.",
  testimonialsTitle: "Winner Testimonials",
  testimonialsSubtitle: "Real stories from our winners",
  testimonialsFilterLabel: "Filter testimonials",
  testimonialsFilter_all: "All",
  testimonialsFilter_horizontal: "Horizontal",
  testimonialsFilter_vertical: "Vertical",
  testimonialsEmpty: "No testimonials available yet",
  testimonialsPaginationLabel: "Testimonials pagination",
  testimonialsPrevPage: "Previous page",
  testimonialsNextPage: "Next page",
  testimonialsPage: "Page",

  stickyRegisterTitle: "Register & Win!",
  stickyRegisterSubtitle: "Create your free account and start playing now",
  stickyRegisterAlreadyHaveAccount: "Already have an account?",
  stickyRegisterLogin: "Log in",
};
